import "./Breakdown.css";
import SectionHeading from "@/components/SectionHeading/SectionHeading";
import LinkWithArrowIcon from "@/components/LinkWithArrowIcon/LinkWithArrowIcon";

// -----------------------------------------------------------------------------------------

export default function Breakdown() {
	return (
		<section className="breakdown-section">
			<SectionHeading heading="Breakdown" number={7} />

			<div>
				View a sample breakdown in:
				<LinkWithArrowIcon
					text="Google Sheets"
					href="https://docs.google.com/spreadsheets/d/1xqlmIhihBo-qnkEtjiBPx-udaTSryvsjc0odVB0flYk/edit?usp=sharing"
					color="var(--primary-mid)"
					hoverColor="var(--primary-mid-hover)"
				/>
			</div>

			<table>
				{/* Header */}
				<thead>
					<tr>
						<th scope="col">Category</th>
						<th scope="col">Allocation</th>
						<th scope="col">Cost [USD]</th>
						<th scope="col">Itemization</th>
					</tr>
				</thead>

				{/* Body */}
				<tbody>
					{/* row */}
					<tr>
						<th scope="row">FTEs – Scientists, Engineers, Support Staff</th>
						<td>35%</td>
						<td>13.2B</td>
						<td>
							412M/year for 400–450 FTEs:
							<ol>
								<li>• 150–175 Senior Scientists/Engineers ($330K/year)</li>
								<li>• 150–175 Junior Scientists/Engineers ($180K/year)</li>
								<li>• 100 Support Staff ($120K/year)</li>
							</ol>
						</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Compute</th>
						<td>20%</td>
						<td>7.5B</td>
						<td>
							Equivalent to 200-350 petaFLOP/s sustained over project:
							<ol>
								<li>• 50,000–60,000 high-end GPUs</li>
								<li>• 15–20 MW power usage</li>
								<li>• $235M/year for hardware upgrades and operations</li>
							</ol>
						</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Hardware</th>
						<td>12%</td>
						<td>4.5B</td>
						<td>
							Research infrastructure:
							<ol>
								<li>• 3–4 major research facilities ($1.5B)</li>
								<li>• Specialized imaging equipment ($1B)</li>
								<li>• Lab equipment and tools ($2B)</li>
								<li>• 141M/year for maintenance and upgrades</li>
							</ol>
						</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Contingency Reserve</th>
						<td>8%</td>
						<td>3.0B</td>
						<td>94M/year for Risk mitigation fund</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Management Reserve</th>
						<td>8%</td>
						<td>3.0B</td>
						<td>59M/year for Unforeseen challenges fund</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Operational Overhead</th>
						<td>5%</td>
						<td>1.9B</td>
						<td>
							59M/year for facility operations:
							<ol>
								<li>• Utilities</li>
								<li>• Maintenance</li>
								<li>• Security</li>
								<li>• Administrative support</li>
							</ol>
						</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Quality Management</th>
						<td>5%</td>
						<td>1.9B</td>
						<td>
							35M/year for validation processes and quality assurance teams
						</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Consulting Services</th>
						<td>3%</td>
						<td>1.1B</td>
						<td>35M/year for external experts and reviewers</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Materials & Consumables</th>
						<td>3%</td>
						<td>1.1B</td>
						<td>29M/year for research supplies and materials</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Licenses</th>
						<td>2.5%</td>
						<td>942.5M</td>
						<td>24M/year for software and technology licenses</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Training</th>
						<td>2%</td>
						<td>754M</td>
						<td>24M/year for staff development programs</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Travel & Events</th>
						<td>2%</td>
						<td>754M</td>
						<td>12M/year for conferences and collaborations</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Logistics</th>
						<td>1%</td>
						<td>377M</td>
						<td>12M/year for supply chain management</td>
					</tr>
					{/* row */}
					<tr>
						<th scope="row">Miscellaneous</th>
						<td>1%</td>
						<td>377M</td>
						<td>6M/year for miscellaneous expenses</td>
					</tr>
				</tbody>

				{/* Footer */}
				<tfoot>
					<tr>
						<th scope="row">Total</th>
						<td>100%</td>
						<td>37.7B</td>
						<td />
					</tr>
				</tfoot>
			</table>
		</section>
	);
}
